<script>
  export default {
    mounted() {
    },
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pedidos-compras/componentes/LiberarPedidosCompra.vue